export enum DUMMY_PORTAL_MESSAGE_EVENT_TYPE {
  GET_PORTAL_CONFIG = 'EPILOT/GET_PARENT_PORTAL_CONFIG',
  PORTAL_CONFIG_UPDATE = 'EPILOT/PORTAL_CONFIG_UPDATE',
  GET_PORTAL_DESIGN = 'EPILOT/GET_PORTAL_DESIGN',
  PORTAL_DESIGN_RECEIVED = 'EPILOT/PORTAL_DESIGN_RECEIVED',
  PORTAL_CONFIG_RECEIVED = 'EPILOT/PORTAL_CONFIG_RECEIVED',
  PORTAL_DESIGN_UPDATE = 'EPILOT/PORTAL_DESIGN_UPDATE',
  PORTAL_PAGE_UPDATE = 'EPILOT/PORTAL_PAGE_UPDATE',
  HYDRATE_PORTAL_PAGE_INFO = 'EPILOT/HYDRATE_PORTAL_PAGE_INFO',
  // Builder pushes data (e.g. schemas) into the portal's mock store
  BUILDER_DATA_PUSH = 'EPILOT/PORTAL_BUILDER_DATA_PUSH',

  // Preview lifecycle events
  PREVIEW_TOKEN_CLEAR = 'EPILOT/PREVIEW_TOKEN_CLEAR',
  PREVIEW_LOADING = 'EPILOT/PREVIEW_LOADING',

  // Preview proxy events — builder acts as caching proxy for API calls
  PREVIEW_PROXY_MODE = 'EPILOT/PREVIEW_PROXY_MODE',
  PREVIEW_API_REQUEST = 'EPILOT/PREVIEW_API_REQUEST',
  PREVIEW_API_RESPONSE = 'EPILOT/PREVIEW_API_RESPONSE',
  PREVIEW_CACHE_INVALIDATE = 'EPILOT/PREVIEW_CACHE_INVALIDATE'
}
